import { Button, ButtonProps, Text } from '@chakra-ui/react';
import DecimalJS from 'decimal.js';
import { forwardRef, Ref } from 'react';
import { GetBalanceReturnType } from 'wagmi/actions';

export const HeaderMenuButton = forwardRef(
  (props: ButtonProps & { address: string; balancedata?: GetBalanceReturnType }, ref: Ref<HTMLButtonElement>) => (
    <Button
      ref={ref}
      bg="brand.staticGray.500"
      color="brand.staticWhite"
      pl={4}
      pr={2}
      py={4}
      ml={4}
      fontWeight="semibold"
      fontSize="xs"
      borderRadius={8}
      borderWidth={0}
      w="auto"
      _hover={{}}
      {...props}
    >
      <Text as="span" fontSize="md">
        {props.balancedata?.formatted &&
          new DecimalJS(props.balancedata.formatted).toFixed(4, DecimalJS.ROUND_FLOOR)}
        <Text as="span" fontSize="xs" ml={1}>
          {props.balancedata?.symbol}
        </Text>
      </Text>
      <Text
        // TODO: register this bg as variant
        background="linear-gradient(to right, var(--chakra-colors-brand-purple-100), var(--chakra-colors-brand-pink))"
        borderRadius={4}
        ml={4}
        px={2}
        py={1}
      >
        {props.address}
      </Text>
    </Button>
  )
);
